if (typeof CartForm !== 'function') {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach(item => {
        const remove = item.querySelector('.remove');
        if (remove) {
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');
          remove.addEventListener('click', e => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector('.qty');
        if (qty) {
          qty.addEventListener(
            'input',
            debounce(e => {
              e.preventDefault();
              e.target.blur();
              this.updateCartQty(item, parseInt(qty.value));
            }, 500)
          );
          qty.addEventListener('click', e => {
            e.target.select();
          });
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form.classList.add('processing');
      const existingAlert = this.querySelector('.alert');
      if (existingAlert) existingAlert.remove();

      const body = JSON.stringify({
        line: parseInt(item.dataset.line),
        quantity: newQty
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript'
        },
        body
      })
        .then(response => response.json())
        .then(response => {
          if (response.status == 422) {
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            alert.innerHTML =
              typeof response.description === 'string'
                ? response.description
                : response.message;
          }
          return fetch('?section_id=helper-cart');
        })
        .then(response => response.text())
        .then(text => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const cartItems = document.getElementById('AjaxCartForm');
          cartItems.innerHTML = doc.getElementById('AjaxCartForm').innerHTML;
          cartItems.ajaxifyCartItems();

          document.getElementById('AjaxCartSubtotal').innerHTML = doc.getElementById('AjaxCartSubtotal').innerHTML;

          document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
            elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
          });
          document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
            elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
          });

          const count = parseInt(cartItems.querySelector('[data-cart-count]')?.textContent || '0');
          const drawer = document.getElementById('site-cart-sidebar');
          if (drawer) {
            drawer.classList.toggle('cart-is-empty', count === 0);
            drawer.classList.toggle('cart-is-full', count > 0);
          }

          if (alert) {
            this.form.prepend(alert);
          }

          this.dispatchEvent(new Event('cart-updated'));
        })
        .catch(e => {
          console.error(e);
          const errorAlert = document.createElement('span');
          errorAlert.classList.add('alert', 'alert--error');
          errorAlert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(errorAlert);
        })
        .finally(() => {
          this.form.classList.remove('processing');
          document.dispatchEvent(new CustomEvent("zapiet:start"));
        });
    }
  }

  if (!customElements.get('cart-form')) {
    customElements.define('cart-form', CartForm);
  }
}

if (typeof CartProductQuantity !== 'function') {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
    }

    changeCartInput() {
      setTimeout(() => {
        document.getElementById('AjaxCartForm').updateCartQty(
          this.closest('[data-js-cart-item]'),
          parseInt(this.querySelector('.qty').value)
        );
      }, 50);
    }
  }

  if (!customElements.get('cart-product-quantity')) {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch('?section_id=helper-cart')
      .then(response => response.text())
      .then(text => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = doc.getElementById('AjaxCartForm').innerHTML;
        cartItems.ajaxifyCartItems();

        document.getElementById('AjaxCartSubtotal').innerHTML = doc.getElementById('AjaxCartSubtotal').innerHTML;

        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
        });
        document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
          elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
        });

        const count = parseInt(cartItems.querySelector('[data-cart-count]')?.textContent || '0');
        const drawer = document.getElementById('site-cart-sidebar');
        if (drawer) {
          drawer.classList.toggle('cart-is-empty', count === 0);
          drawer.classList.toggle('cart-is-full', count > 0);
        }

        const sidebar = document.querySelector('[data-js-site-cart-sidebar]');
        if (sidebar && typeof sidebar.show === 'function') sidebar.show();

        const recommendations = document.querySelector('cart-recommendations');
        if (recommendations) {
          recommendations.innerHTML = '';
          recommendations.generateRecommendations();
        }
      });
  };
}

// MutationObserver to toggle class in real-time
new MutationObserver((mutations, observer) => {
  const drawer = document.getElementById('site-cart-sidebar');
  if (!drawer) return;
  const cartCount = parseInt(document.querySelector('[data-cart-count]')?.textContent || '0');
  drawer.classList.toggle('cart-is-empty', cartCount === 0);
  drawer.classList.toggle('cart-is-full', cartCount > 0);
}).observe(document.querySelector('.cart-form'), {
  attributes: false,
  childList: true,
  subtree: true
});
